CampoExtraIframeDirectiva.$inject = [];

export default function CampoExtraIframeDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'campoExtra': '=',
            'updateActive': '=',
            'cargando': '=',
            'claseRow': '@',
            'modelId': '='
        },
        template: require('./campos-extra-iframe.html'),
        controller: 'CamposExtraIframeCtrl as campExtIframe',
        bindToController: true
    }
}